import { render, staticRenderFns } from "./Textarea.vue?vue&type=template&id=2eea37ee&scoped=true"
import script from "./Textarea.vue?vue&type=script&lang=ts"
export * from "./Textarea.vue?vue&type=script&lang=ts"
import style0 from "./Textarea.vue?vue&type=style&index=0&id=2eea37ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eea37ee",
  null
  
)

export default component.exports